// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"6ff004f5","376":"48c98298","377":"8d0628b6","498":"ff6a8844","513":"bc3a3827","622":"e5a2c56c","896":"0334c3ba"}[chunkId] + ".chunk.js";
};